<main class="main">
  <section>
    <h1>404 Not Found</h1>
    <div class="card">
      The requested document was not found on this server.
    </div>
  </section>
</main>
